The output of the `updatePostedPositionProfile` mutation.
